// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__1y8Ym","title":"style__title__F0tMK","description":"style__description__--ydp","component":"style__component__1FRin"};